export default __webpack_public_path__ + "static/media/k11.66b8098f.jpg";